import { render } from "./ProviderShow.vue?vue&type=template&id=e59ef0c4"
import script from "./ProviderShow.vue?vue&type=script&lang=js"
export * from "./ProviderShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__